import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AddEmployeeModel.css";
import { Box, Button } from "@mui/material";
import axios from "axios";
import { assetbtn } from "../../Assets/CSS/Button";

const AddEmployeeModal = ({ onClose, onEmployeeAdded }) => {
  console.log("AddEmployeeModel Render");
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const steps = [
    "Personal Info",
    "Address Details",
    "Job Details",
    "Assign Assets",
    "Leave Balance",
    // "Account Details",
  ];
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    dateOfJoining: "",
    designation: "",
    personalEmail: "",
    // officeEmail: "",
    countryCode: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
    managerId: "",
    departmentId: "",
    roles: [""],
    addresses: {
      additionalProp1: {
        landMark: "",
        streetLine1: "",
        streetLine2: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        metadata: "",
        primaryAddress: true,
      },
    },
    assentList: [" "],
    totalAllocatedSickLeave: "",
    totalAllocatedCasualLeave: "",
    totalAllocatedEarnedLeave: "",
    profileImage: null,
  });
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [departments, setDepartments] = useState();
  const [assets, setAssets] = useState([""]);
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    console.log("Modal Mounted");

    return () => {
      console.log("Modal Unmounted");
    };
  }, []);

  // const handleAssetChange = (index, e) => {
  //   const newAssets = [...assets];
  //   newAssets[index][e.target.name] = e.target.value;
  //   setAssets(newAssets);
  // };
  // const addAsset = () => {
  //   setAssets([...assets, { assetName: "" }]);
  // };

  // const removeAsset = (index) => {
  //   const newAssets = assets.filter((_, i) => i !== index);
  //   setAssets(newAssets);
  // };
  const handleAssetChange = (index, value) => {
    const updatedAssets = [...assets];
    updatedAssets[index] = value;
    setAssets(updatedAssets);

    // sync with formData
    setFormData((prev) => ({
      ...prev,
      assentList: updatedAssets.filter((a) => a.trim() !== ""),
    }));
  };

  const addAsset = () => {
    setAssets([...assets, ""]);
  };

  const removeAsset = (index) => {
    const updatedAssets = assets.filter((_, i) => i !== index);
    setAssets(updatedAssets);

    setFormData((prev) => ({
      ...prev,
      assentList: updatedAssets.filter((a) => a.trim() !== ""),
    }));
  };

  const fetchDepartments = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/depts?page=0&size=10`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // if API returns paginated data
      if (response.data.content) {
        setDepartments(response.data.content);
        console.log(response.data.content);
      } else {
        // if API directly returns array
        setDepartments(response.data);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  const fetchmanager = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps?page=0&size=1000`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(response.data.content, "emp data for manager");
      // Filter only managers
      const managersfilter = (response.data.content || []).filter((emp) =>
        emp.roles.includes("ROLE_MANAGER"),
      );
      setManagers(managersfilter);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
    fetchmanager();
  }, []);
  const validateStep = () => {
    const errors = [];
    const nameRegex = /^[a-zA-Z\s]+$/; // Only alphabets and spaces
    const maxLength = 20;
    const mobileRegex = /^\d{10}$/; // Exactly 10 digits
    const personalEmailPattern =
      /^(?!.*\.\.)(?!\.)([a-zA-Z0-9._%+-]{2,})(?<!\.)@gmail\.com$/;
    if (step === 1) {
      if (!formData.firstName.trim()) {
        errors.push("First Name is required.");
      } else if (!nameRegex.test(formData.firstName.trim())) {
        errors.push("First Name should contain only letters.");
      } else if (formData.firstName.trim().length > maxLength) {
        errors.push("First Name should not exceed 20 characters.");
      }
      // if (!formData.middleName.trim()) {
      //   errors.push("Middle Name is required.");
      // } else if (!nameRegex.test(formData.middleName.trim())) {
      //   errors.push("Middle Name should contain only letters.");
      // } else if (formData.middleName.trim().length > maxLength) {
      //   errors.push("Middle Name should not exceed 20 characters.");
      // }

      // last Name
      if (!formData.lastName.trim()) {
        errors.push("Last Name is required.");
      } else if (!nameRegex.test(formData.lastName.trim())) {
        errors.push("Last Name should contain only letters.");
      } else if (formData.lastName.trim().length > maxLength) {
        errors.push("Last Name should not exceed 20 characters.");
      }
      // emailID
      if (!formData.personalEmail.trim()) {
        errors.push("Email ID is required.");
      } else if (!personalEmailPattern.test(formData.personalEmail.trim())) {
        errors.push("Invalid Format.");
      }
      if (!formData.mobileNumber.trim()) {
        errors.push("Mobile Number is required.");
      } else if (!/^\d{10}$/.test(formData.mobileNumber.trim())) {
        errors.push(
          "Mobile Number must be exactly 10 digits and contain only numbers.",
        );
      }

      if (!formData.dateOfBirth.trim())
        errors.push("Date of Birth is required.");
    }
    if (step === 2) {
      const address = formData.addresses.additionalProp1;

      // LandMark
      if (!address.landMark.trim()) {
        errors.push("Landmark is required.");
      } else if (address.landMark.trim().length > 50) {
        errors.push("Landmark should not exceed 50 characters.");
      }

      // StreetLine1
      if (!address.streetLine1.trim()) {
        errors.push("Street Line 1 is required.");
      } else if (address.streetLine1.trim().length > 100) {
        errors.push("Street Line 1 should not exceed 100 characters.");
      }

      // StreetLine2 (optional but length restricted)
      // if (address.streetLine2.trim() && address.streetLine2.trim().length > 100) {
      //   errors.push("Street Line 2 should not exceed 100 characters.");
      // }

      // City
      if (!address.city.trim()) {
        errors.push("City is required.");
      } else if (!/^[A-Za-z\s]+$/.test(address.city.trim())) {
        errors.push("City should contain only letters.");
      } else if (address.city.trim().length > 50) {
        errors.push("City should not exceed 50 characters.");
      }

      // State
      if (!address.state.trim()) {
        errors.push("State is required.");
      } else if (!/^[A-Za-z\s]+$/.test(address.state.trim())) {
        errors.push("State should contain only letters.");
      } else if (address.state.trim().length > 50) {
        errors.push("State should not exceed 50 characters.");
      }

      // Postal Code
      // if (!address.postalCode.trim()) {
      //   errors.push("Postal Code is required.");
      // } else if (!/^\d{5,6}$/.test(address.postalCode.trim())) {
      //   errors.push("Postal Code must be 5 or 6 digits.");
      // }
      if (!address.postalCode.trim()) {
        errors.push("Postal Code is required.");
      } else if (!/^[1-9][0-9]{5}$/.test(address.postalCode.trim())) {
        errors.push("Postal Code must be a valid 6-digit PIN code.");
      }

      // Country
      if (!address.country.trim()) {
        errors.push("Country is required.");
      } else if (!/^[A-Za-z\s]+$/.test(address.country.trim())) {
        errors.push("Country should contain only letters.");
      } else if (address.country.trim().length > 50) {
        errors.push("Country should not exceed 50 characters.");
      }

      // Metadata (optional but length restricted)
      // if (address.metadata.trim() && address.metadata.trim().length > 100) {
      //   errors.push("Metadata should not exceed 100 characters.");
      // }

      // Primary Address (required → should be true/false)
      // if (address.primaryAddress === "" || address.primaryAddress === null) {
      //   errors.push("Primary Address selection is required.");
      // }
    }

    if (step === 3) {
      if (!formData.dateOfJoining.trim())
        errors.push("Joining Date is required.");
      // if (!formData.departmentId.trim()) {
      //   errors.push("Department is required.");
      // }
      // } else if (!nameRegex.test(formData.departmentId.trim())) {
      //   errors.push("Department should contain only letters.");
      // }
      // else if (formData.departmentId.trim().length > maxLength) {
      //   errors.push("Department should not exceed 20 characters.");
      // }
      // designation
      if (!formData.designation.trim()) {
        errors.push("Designation is required.");
      } else if (!nameRegex.test(formData.designation.trim())) {
        errors.push("Designation should contain only letters.");
      } else if (formData.designation.trim().length > maxLength) {
        errors.push("Designation should not exceed 20 characters.");
      }
      // Role
      if (!formData.roles[0].trim()) errors.push("Role is required.");
      if (!formData.managerId.trim()) errors.push("Manager ID is required.");
    }

    if (step === 5) {
      if (!formData.totalAllocatedSickLeave.trim())
        errors.push("Sick Leave is required.");
      if (!formData.totalAllocatedCasualLeave.trim())
        errors.push("Casual Leave is required.");
      if (!formData.totalAllocatedEarnedLeave.trim())
        errors.push("Other Leave is required.");
    }

    // if (step === 6) {
    //   if (!formData.officeEmail.trim())
    //     errors.push("Company Email is required.");
    //   // Password validation
    //   const password = formData.password.trim();
    //   const confirmPassword = formData.confirmPassword.trim();

    //   if (!password) {
    //     errors.push("Password is required.");
    //   } else {
    //     // Example: Minimum 8 chars, at least 1 uppercase, 1 lowercase, 1 number, 1 special char
    //     const passwordPattern =
    //       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    //     if (!passwordPattern.test(password)) {
    //       errors.push(
    //         "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
    //       );
    //     }
    //   }

    //   if (!confirmPassword) {
    //     errors.push("Confirm Password is required.");
    //   } else if (password !== confirmPassword) {
    //     errors.push("Passwords do not match.");
    //   }
    // }
    return errors;
  };
  const getEighteenYearsAgoDate = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    return today.toISOString().split("T")[0];
  };

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // Handle file selection
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   // for address fields
  //   if ([
  //     "landMark", "streetLine1", "streetLine2",
  //     "city", "state", "postalCode", "country",
  //     "metadata", "primaryAddress"
  //   ].includes(name)) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       addresses: {
  //         ...prev.addresses,
  //         additionalProp1: {
  //           ...prev.addresses.additionalProp1,
  //           [name]: value,
  //         },
  //       },
  //     }));
  //   } else {
  //     // for top-level fields
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // for address fields
    if (
      [
        "landMark",
        "streetLine1",
        "streetLine2",
        "city",
        "state",
        "postalCode",
        "country",
        "metadata",
        //  "primaryAddress"
      ].includes(name)
    ) {
      setFormData((prev) => ({
        ...prev,
        addresses: {
          ...prev.addresses,
          additionalProp1: {
            ...prev.addresses.additionalProp1,
            [name]: value,
          },
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: name === "departmentId" ? parseInt(value, 10) || "" : value,
      }));
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    // if (file) {
    //   setFileName(file.name);
    //   setSelectedImage(URL.createObjectURL(file));
    // }
    if (file) {
      setFormData((prev) => ({ ...prev, profileImage: file }));
      setSelectedImage(URL.createObjectURL(file));
    } else {
      setFormData((prev) => ({ ...prev, profileImage: null }));
      setSelectedImage(null);
    }
  };
  // const handleNext = () => {
  //   if (step < 5) {
  //     const errors = validateStep();
  //     if (errors.length > 0) {
  //       errors.forEach((err) => toast.error(err));
  //       return; // prevent advancing step
  //     }
  //     setStep(step + 1);
  //   }
  // };
  const handleNext = () => {
    console.log("Next clicked");
    const errors = validateStep();
    console.log(errors);

    if (errors.length > 0) {
      errors.forEach((err) => toast.error(err));
      return;
    }

    setStep((prev) => {
      console.log("Changing", prev, "to", prev + 1);
      return prev + 1;
    });
  };

  useEffect(() => {
    console.log("STEP =", step);
  }, [step]);

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    console.log("Actual submit");

    const errors = validateStep();
    if (errors.length > 0) {
      errors.forEach((err) => toast.error(err));
      return;
    }

    try {
      setLoading(true);
      const {
        totalAllocatedSickLeave,
        totalAllocatedCasualLeave,
        totalAllocatedEarnedLeave,
        ...dataToSend
      } = formData;

      const formattedData = {
        ...formData,
        addresses: {
          home: dataToSend.addresses.additionalProp1,
        },
      };
      console.log("payload Add new Employee...", formattedData);
      const formPayload = new FormData();
      formPayload.append(
        "empDTO",
        new Blob([JSON.stringify(formattedData)], { type: "application/json" }),
      );

      if (formData.profileImage) {
        formPayload.append("profileImage", formData.profileImage); // Use the actual File object
      }

      console.log("payload Add new Employee", formPayload);
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps`,
        formPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // DON'T set Content-Type manually!
          },
        },
      );
      if (response.status === 201) {
        console.log("payload Add new Employee", formPayload);
        toast.success("Employee added successfully!");
      }
      onEmployeeAdded();
      setTimeout(() => onClose(), 500);
    } catch (error) {
      console.error("Error registering employee:", error);
      const serverMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data ||
        "Failed to add employee. Please try again.";
      toast.error(serverMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token"); // if auth is required
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/roles?page=0&size=10`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Assuming API returns something like: { content: [ { roleName, createdBy, createdOn } ] }
        setHistoryData(res.data.content || []);
      } catch (error) {
        console.error("Error fetching role history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);
  return (
    <div className="modal-overlay">
      <ToastContainer position="top-right" autoClose={3000} />
      <div
        style={{
          backgroundColor: "white",
          padding: "2vh",
          borderRadius: "8px",
          width: "85%",
          height: "90%",
          maxWidth: "623px",
          maxHeight: "100%",
          overflowY: "auto",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          display: "flex",
          flexDirection: "column",
          //scrollbarWidth: "none", // Note: This only affects Firefox
          overflowY: "auto",
        }}
      >
        <div className="modal-header">
          <p>Add New Employee</p>
          <button type="button" onClick={onClose} className="close-btn">
            <Icon
              icon="iconoir:cancel"
              width="28"
              height="28"
              color="#909090"
              className="mb-3"
            />
          </button>
        </div>

        <div className="step-indicator">
          {steps.map((label, index) => {
            const isCompleted = step > index + 1;
            const isActive = step === index + 1;

            return (
              <div
                className={`step-item ${
                  isCompleted ? "completed" : isActive ? "active" : ""
                }`}
                key={index}
              >
                <div
                  className={`step-circle ${
                    isCompleted ? "completed" : isActive ? "active" : ""
                  }`}
                >
                  {isCompleted ? (
                    <Icon icon="material-symbols:done" width="14" height="14" />
                  ) : (
                    index + 1
                  )}
                </div>
                {index !== steps.length - 1 && (
                  <div
                    className="step-line"
                    style={{
                      borderTop:
                        step > index + 1
                          ? "2px solid #00AFEF"
                          : "2px dotted #C3C3C3",
                    }}
                  ></div>
                )}
                <div className="step-label">{label}</div>
                <hr className="line" />
              </div>
            );
          })}
        </div>
        <form className="modal-forms" onSubmit={(e) => e.preventDefault()}>
          {step === 1 && (
            <>
              <div className="form-groups">
                <label>
                  First Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder=""
                />
              </div>
              <div className="form-groups">
                <label>Middle Name</label>
                <input
                  name="middleName"
                  value={formData.middleName}
                  onChange={handleChange}
                  placeholder=""
                />
              </div>
              <div className="form-groups">
                <label>
                  Last Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder=""
                />
              </div>
              <div className="form-groups">
                <label>
                  Date of Birth<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  max={getEighteenYearsAgoDate()} // Prevents selection if age < 18
                  onClick={(e) => e.target.showPicker()}
                />
              </div>
              <div className="form-groups">
                <label>
                  Mobile Number<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder=""
                  maxLength={10} // restricts to 10 characters
                  inputMode="numeric" // brings up numeric keyboard on mobile
                  pattern="\d*"
                />
              </div>
              <div className="form-groups">
                <label>
                  Email ID<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  name="personalEmail"
                  value={formData.personalEmail}
                  onChange={handleChange}
                  placeholder=" Personal Email"
                />
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <div className="form-groups">
                <label>
                  landMark<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="landMark"
                  value={formData.addresses.additionalProp1.landMark}
                  onChange={handleChange}
                  max={new Date().toISOString().split("T")[0]} // Disables future dates
                />
              </div>
              <div className="form-groups">
                <label>
                  streetLine1<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="streetLine1"
                  value={formData.addresses.additionalProp1.streetLine1}
                  onChange={handleChange}
                  placeholder="Enter streetLine1"
                />
              </div>
              <div className="form-groups">
                <label>streetLine2</label>
                <input
                  name="streetLine2"
                  value={formData.addresses.additionalProp1.streetLine2}
                  onChange={handleChange}
                  placeholder="Enter streetLine2"
                />
              </div>
              <div className="form-groups">
                <label>
                  city<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="city"
                  value={formData.addresses.additionalProp1.city}
                  onChange={handleChange}
                  placeholder="Enter city"
                />
              </div>

              <div className="form-groups">
                <label>
                  state<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="state"
                  value={formData.addresses.additionalProp1.state}
                  onChange={handleChange}
                  placeholder="Enter state"
                />
              </div>
              <div className="form-groups">
                <label>
                  postal Code <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="postalCode"
                  value={formData.addresses.additionalProp1.postalCode}
                  onChange={handleChange}
                  placeholder="Enter postalCode"
                  maxLength={6}
                />
              </div>
              <div className="form-groups">
                <label>Country Code</label>
                <select
                  name="countryCode"
                  value={formData.addresses.additionalProp1.countryCode}
                  onChange={handleChange}
                >
                  <option value="">Select country code</option>
                  <option value="+1">+1 (USA)</option>
                  <option value="+91">+91 (India)</option>
                  <option value="+61">+61 (Australia)</option>
                  {/* Add more codes as needed */}
                </select>
              </div>

              <div className="form-groups">
                <label>
                  country <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="country"
                  value={formData.addresses.additionalProp1.country}
                  onChange={handleChange}
                  placeholder="Enter country"
                />
              </div>
              <div className="form-groups">
                <label>metadata</label>
                <input
                  name="metadata"
                  value={formData.addresses.additionalProp1.metadata}
                  onChange={handleChange}
                  placeholder="Enter metadata"
                />
              </div>
              {/* <div className="form-groups">
                <label>primaryAddress</label>
                <input
                  name="primaryAddress"
                  value={formData.addresses.additionalProp1.primaryAddress}
                  onChange={handleChange}
                  placeholder="Enter primaryAddress"
                />
              </div> */}
            </>
          )}

          {step === 3 && (
            <>
              <div className="form-groups">
                <label>
                  Joining Date<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="date"
                  name="dateOfJoining"
                  value={formData.dateOfJoining}
                  onChange={handleChange}
                  max={new Date().toISOString().split("T")[0]} // Disables future dates
                  onClick={(e) => e.target.showPicker()}
                />
              </div>
              <div className="form-groups">
                <label>
                  Department Id<span style={{ color: "red" }}>*</span>
                </label>

                <select
                  name="departmentId"
                  value={formData.departmentId}
                  onChange={handleChange}
                >
                  <option value="" style={{ fontSize: "12px" }}>
                    Select Department
                  </option>
                  {departments?.map((dept) => (
                    <option key={dept.departmentId} value={dept.departmentId}>
                      {dept.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-groups">
                <label>
                  Designation<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  placeholder="Enter Designation"
                />
              </div>
              {/* <div className="form-groups">
                <label>Role</label>
                <input
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  placeholder="Enter Role"
                />
              </div> */}
              <div className="form-groups">
                <label>
                  Role<span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="role"
                  value={formData.roles[0]}
                  onChange={(e) =>
                    setFormData({ ...formData, roles: [e.target.value] })
                  }
                  // className="form-control"
                >
                  <option value="">Select Role</option>
                  {/* <option value="EMP">Employee</option>
                  <option value="ADMIN">Admin</option>
                  <option value="MANAGER">Manager</option> */}
                  {historyData.map((role) => {
                    const cleanRole = role.userRole.replace("ROLE_", "");

                    return (
                      <option key={role.id} value={cleanRole}>
                        {cleanRole}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-groups">
                <label>
                  Manager ID <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="managerId"
                  value={formData.managerId}
                  onChange={handleChange}
                >
                  <option value="">Select Manager</option>
                  {managers.map((manager) => (
                    <option key={manager.id} value={manager.empId}>
                      {manager.empId}
                    </option>
                  ))}
                </select>
              </div>

              {/* <div className="form-groups">
                <label>HR ID</label>
                <input
                  name="hrId"
                  value={formData.hrId}
                  onChange={handleChange}
                  placeholder="Enter HR ID"
                />
              </div> */}
            </>
          )}

          {step === 4 && (
            <div className="form-groups">
              {assets.map((asset, index) => (
                <div className="asset-row" key={index}>
                  <label className="asset-label">Asset name</label>

                  <div className="asset-input-row">
                    <input
                      type="text"
                      value={asset}
                      onChange={(e) => handleAssetChange(index, e.target.value)}
                      className="asset-input"
                    />

                    {assets.length > 1 && (
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => removeAsset(index)}
                      >
                        <Icon icon="material-symbols:remove-rounded" />
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <button
                type="button"
                style={assetbtn}
                className="mt-5"
                onClick={addAsset}
              >
                <Icon icon="material-symbols:add-rounded" />
                Add Asset
              </button>
            </div>
          )}

          {step === 5 && (
            <>
              <div className="form-groups">
                <label>
                  Sick Leave Balance<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="totalAllocatedSickLeave"
                  value={formData.totalAllocatedSickLeave}
                  onChange={handleChange}
                  placeholder="Enter Sick Leave Balance"
                />
              </div>
              <div className="form-groups">
                <label>
                  Casual Leave Balance<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="totalAllocatedCasualLeave"
                  value={formData.totalAllocatedCasualLeave}
                  onChange={handleChange}
                  placeholder="Enter Casual Leave Balance"
                />
              </div>
              <div className="form-groups">
                <label>
                  Other Leave Balance<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="totalAllocatedEarnedLeave"
                  value={formData.totalAllocatedEarnedLeave}
                  onChange={handleChange}
                  placeholder="Enter Other Leave Balance"
                />
              </div>
            </>
          )}
          {/* {step === 6 && (
            <>
              <div className="form-groups">
                <label>Company Email<span style={{ color: "red" }}>*</span></label>
                <input
                  name="officeEmail"
                  value={formData.officeEmail}
                  onChange={handleChange}
                  placeholder="abcdefg@raksoftech.com"
                  required
                  pattern="^(?!.*\.\.)(?!\.)[a-zA-Z0-9._]{2,}(?<!\.)@raksoftech\.com$"
                  title="Please enter a valid raksoftech.com email (e.g., abc@raksoftech.com)"
                />
              </div>

              <div className="form-groups" style={{ position: 'relative' }}>
                <label>Password<span style={{ color: "red" }}>*</span></label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  required
                  style={{ paddingRight: "35px" }}
                />
                <Icon
                  icon={showPassword ? "mdi:eye-off" : "mdi:eye"}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#888"
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>

              <div className="form-groups" style={{ position: 'relative' }}>
                <label>Confirm Password<span style={{ color: "red" }}>*</span></label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm Password"
                  required
                  style={{ paddingRight: "35px" }} // space for icon
                />
                <Icon
                  icon={showConfirmPassword ? "mdi:eye-off" : "mdi:eye"}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#888"
                  }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              </div>

              {/* <div className="form-groups">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label>
                    Profile Image<span style={{ color: "red" }}>*</span>
                  </label>
                  <label
                    htmlFor="file-upload"
                    style={{ color: "#00AFEF", cursor: "pointer" }}
                  >
                    Reupload
                  </label>
                </div>

                <input
                  id="file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className=""
                />

                

                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Profile Preview"
                    className="mt-3 Add-Profile rounded-circle"
                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                  />
                )}
              </div> 
            </>
          )} */}

          <div className="form-actions-add">
            {step > 1 ? (
              <button type="button" className="back-btn" onClick={handleBack}>
                Back
              </button>
            ) : (
              <div className="spacer" /> // pushes "Next" to the right on Step 1
            )}

            {step < 5 ? (
              <button type="button" className="submit-btn" onClick={handleNext}>
                Next
              </button>
            ) : (
              // <button type="submit" className="create-emp-btn">
              //   Create Employee
              // </button>
              <button
                type="submit"
                className="btn btn-primary create-emp-btn"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create Employee"
                )}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployeeModal;
